import {ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiTypography = ({typography}: Tokens): ThemeOptions['components'] => {
  const {desktop} = typography;
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: desktop.body1.margin.bottom
        },
        paragraph: {
          marginBottom: desktop.body2.margin.bottom
        }
      }
    }
  };
};
